export default __webpack_public_path__ + "static/media/89.5d1ceaa5.jpg";